/**
 * Get current application domain
 */
export const getAppDomain = (): string => {
  const { hostname } = new URL(window.location.href);
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);
  if (isLocalhost) {
    return "https://dev.template.snapmenu.ai";
  }
  return `https://${hostname}`;
};

/**
 * Check template domain
 */
export const isTemplateDomain = (): boolean => {
  const hostname = window.location.hostname;
  const templateDomains = [
    "template.snapmenu.ai",
    "dev.template.snapmenu.ai",
    "uat.template.snapmenu.ai",
    "localhost",
  ];
  return templateDomains.includes(hostname);
};

/**
 * Parent restaurant URL
 *
 * Example:
 * /parent-restaurants/b1da1825-7eeb-4b88-9b5a-349a660bded9
 */
export const getParentRestaurantIdFromUrl = (): string | null => {
  const pathname = window.location.pathname;

  const parts = pathname.split("/").filter(Boolean);

  if (parts[0] === "parent-restaurants" && parts[1]) {
    const uuid = parts[1];

    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    if (uuidRegex.test(uuid)) {
      return uuid;
    }
  }

  return null;
};

/**
 * Parent restaurant query
 *
 * ?parentRestaurantId=uuid
 */
export const getParentRestaurantIdFromQuery = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get("parentRestaurantId");
};

/**
 * Preview/Edit URL
 *
 * Example:
 * /uuid/preview/edit
 */
export const getFranchiseIdFromPreviewUrl = (): string | null => {
  const pathname = window.location.pathname;
  const regex =
    /^\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/preview(?:\/edit)?/i;
  const match = pathname.match(regex);
  return match ? match[1] : null;
};

/**
 * Restaurant query
 *
 * ?restaurantId=uuid
 */
export const getRestaurantIdFromQuery = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get("restaurantId");
};

/**
 * Slug + UUID URL
 *
 * Example:
 * /dominos-e96e3915-ac08-41a5-9579-1fe55b6cb9c2
 */
export const getFranchiseIdFromSlugPath = (): string | null => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  const firstSegment = segments[0];
  if (!firstSegment) {
    return null;
  }
  const regex =
    /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;
  const match = firstSegment.match(regex);
  return match ? match[1] : null;
};

/**
 * Preview mode check
 */
export const isPreviewEditMode = (): boolean => {
  return window.location.pathname.includes("/preview");
};

export const getRestaurantIdFromPaymentSuccessUrl = (): string | null => {
  const pathname = window.location.pathname;

  const regex =
    /^\/menu\/stripe\/payment-success\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

  const match = pathname.match(regex);

  return match ? match[1] : null;
};

export const getRestaurantIdFromPaymentFailedUrl = (): string | null => {
  const pathname = window.location.pathname;

  const regex =
    /^\/menu\/stripe\/payment-failed\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

  const match = pathname.match(regex);

  return match ? match[1] : null;
};